import { render } from "./ReportByBooth.vue?vue&type=template&id=5c48a818&scoped=true&ts=true"
import script from "./ReportByBooth.vue?vue&type=script&lang=ts"
export * from "./ReportByBooth.vue?vue&type=script&lang=ts"

import "./ReportByBooth.vue?vue&type=style&index=0&id=5c48a818&lang=scss&scoped=true"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c48a818"]])

export default __exports__